import { sanitizeParams } from "utils/miscUtils";
import { Client } from "./_clientService";

export async function getDailyReportList({
  startTime,
  endTime,
  pageNo,
  pageSize,
  skipPagination,
  sortDir = 1,
  skipOverallSummary = true,
  platform,
  operator,
  brand,
  externalPlayerId,
  timezone,
}: any) {
  let path = `/report/daily-and-player-summary?pageNo=${pageNo}&pageSize=${pageSize}&skipOverallSummary=${skipOverallSummary}&startTime=${startTime}&endTime=${endTime}`;

  if (skipPagination) path += `&skipPagination=true`;
  if (platform && platform !== "all") path += `&platform=${platform}`;
  if (operator && operator !== "all") path += `&operator=${operator}`;
  if (brand && brand !== "all") path += `&brand=${brand}`;
  if (externalPlayerId) path += `&externalPlayerId=${externalPlayerId}`;
  if (timezone) path += `&timezone=${timezone}`;

  const resp = await new Client({ path }).get();

  return resp;
}

export async function getMarketReportList({
  startTime,
  endTime,
  pageNo,
  pageSize,
  skipPagination = false,
  sortDir = 1,
  platform,
  operator,
  brand,
  externalPlayerId,
  marketType,
}: any) {
  let path = `/report/market-wise-summary?pageNo=${pageNo}&pageSize=${pageSize}&sortDirection=${sortDir}&skipPagination=${true}&startTime=${startTime}&endTime=${endTime}`;

  if (skipPagination) path += `&skipPagination=true`;
  if (platform && platform !== "all") path += `&platform=${platform}`;
  if (operator && operator !== "all") path += `&operator=${operator}`;
  if (brand && brand !== "all") path += `&brand=${brand}`;
  if (externalPlayerId) path += `&externalPlayerId=${externalPlayerId}`;
  if (marketType) path += `&marketType=${marketType}`;

  const resp = await new Client({ path }).get();

  return resp;
}

export async function getPlayerReportList({
  startTime,
  endTime,
  pageNo,
  pageSize,
  skipPagination = false,
  sortDir = 1,
  platform,
  operator,
  brand,
  externalPlayerId,
}: any) {
  let path = `/report/daily-and-player-summary?pageNo=${pageNo}&pageSize=${pageSize}&sortDirection=${sortDir}&skipOverallSummary=${true}&groupByPlayerId=${true}&startTime=${startTime}&endTime=${endTime}`;

  if (skipPagination) path += `&skipPagination=true`;
  if (platform && platform !== "all") path += `&platform=${platform}`;
  if (operator && operator !== "all") path += `&operator=${operator}`;
  if (brand && brand !== "all") path += `&brand=${brand}`;
  if (externalPlayerId) path += `&externalPlayerId=${externalPlayerId}`;

  const resp = await new Client({ path }).get();

  return resp;
}

export async function getTransactionReportList({
  startTime,
  endTime,
  pageNo,
  pageSize,
  skipPagination,
  sortDir = -1,
  platform,
  operator,
  brand,
  externalPlayerId,
  roundId,
  betId,
  transactionType,
  status,
  platformTransactionId,
  numericRoundId,
  platformBetTxnId,
  requestItemId,
  winRequestItemId,
  refundTxnId,
  playerName,
  playerSessionId,
  gameAlias,
  playerCurrencyCode,
  marketType,
  resolved,
  isFreeBet,
  buyBonus,
}: any) {
  let path = `/report/transaction-summary?pageNo=${pageNo}&pageSize=${pageSize}&sortDirection=${sortDir}&startTime=${startTime}&endTime=${endTime}`;
  if (skipPagination) path += `&skipPagination=true`;
  if (platform && platform !== "all") path += `&platform=${platform}`;
  if (operator && operator !== "all") path += `&operator=${operator}`;
  if (brand && brand !== "all") path += `&brand=${brand}`;
  if (externalPlayerId) path += `&externalPlayerId=${externalPlayerId}`;
  if (roundId) path += `&roundId=${roundId}`;
  if (betId) path += `&betId=${betId}`;
  if (transactionType && transactionType !== "all")
    path += `&transactionType=${transactionType}`;
  if (status && status !== "all") path += `&status=${status}`;
  if (platformTransactionId)
    path += `&platformTransactionId=${platformTransactionId}`;
  if (numericRoundId) path += `&numericRoundId=${numericRoundId}`;
  if (platformBetTxnId) path += `&platformBetTxnId=${platformBetTxnId}`;
  if (requestItemId) path += `&requestItemId=${requestItemId}`;
  if (winRequestItemId) path += `&winRequestItemId=${winRequestItemId}`;
  if (refundTxnId) path += `&refundTxnId=${refundTxnId}`;
  if (playerName) path += `&playerName=${encodeURIComponent(playerName)}`;
  if (playerSessionId) path += `&playerSessionId=${playerSessionId}`;
  if (gameAlias) path += `&gameAlias=${gameAlias}`;
  if (playerCurrencyCode) path += `&playerCurrencyCode=${playerCurrencyCode}`;
  if (marketType && marketType !== "all") path += `&marketType=${marketType}`;
  if (resolved && resolved !== "all") path += `&resolved=${resolved}`;
  if (isFreeBet != null) path += `&isFreeBet=${isFreeBet}`;
  if (buyBonus != null) path += `&buyBonus=${buyBonus}`;
  const resp = await new Client({ path }).get();

  return resp;
}

export async function getPbfCoinSummary(params: any) {
  const resp = await new Client({
    path: "/report/pbf-coin-summary",
    payload: params,
  }).post();

  return resp;
}

export async function getDashboardSummary(queryParams: any) {
  const sanitizedParams = sanitizeParams(queryParams);
  const filteredParams = Object.entries(sanitizedParams).reduce(
    (acc: any, [key, value]) => {
      if (value && value !== "all") {
        acc[key] = value;
      }
      return acc;
    },
    {},
  );
  filteredParams.skipReportSummary = String(true);

  const queryString = new URLSearchParams(filteredParams).toString();

  const resp = await new Client({
    path: `/report/daily-and-player-summary?${queryString}`,
  }).get();

  return resp;
}

export const ReportTypes = Object.freeze({
  daily: "daily",
  player: "player",
  txn: "txn",
  market: "market",
  dailyCoin: "dailyCoin",
  playerCoin: "playerCoin",
});

export async function exportReport(data: any) {
  const resp = await new Client({
    path: `/export/report`,
    payload: data,
  }).post();

  return resp;
}

export async function getTransactionInfo(betId: any) {
  const resp = await new Client({
    path: `/report/transaction-summary/info?betTxnId=${betId}`,
  }).get();

  return resp;
}
